import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=ad253b04&scoped=true&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/index/index.less?vue&type=style&index=0&id=ad253b04&lang=less&scoped=true&"
import style1 from "./materialList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad253b04",
  null
  
)

component.options.__file = "materialList.vue"
export default component.exports